exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".option-selectors[data-v-db70c464]{display:flex;flex-wrap:wrap;align-items:flex-start;margin:0 -1rem}.option-selectors .option-selector[data-v-db70c464]{flex:1 1 300px;min-width:min(300px,100% - 1rem);display:flex;align-items:flex-start;margin:0 .5rem}.option-selectors .option-selector .form-group[data-v-db70c464]{flex-grow:1}", ""]);

// exports
